import styled from "styled-components";

export const InputWrapper = styled.div`
    position: relative;
    width: "50%";
    display: inline-block;
`;
export const InputField = styled.div`
    position: relative;
`

export const Input = styled.input`
    width: 100%;
    box-sizing: border-box;
    text-align: center;
    border: 1px solid var(--Blues-Blue-3, #99B7EF);
    border-radius: 4px;
    height: 47px;
    padding-right: 10px;
`;

export const InputLabel = styled.div`


`

export const InputCurrency = styled.div`
    position: absolute;
    right: 5px;
    top: 50%;
    transform: translateY(-50%)
`